var _path;
import * as React from "react";
function SvgChevronLightDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.745 12.536l-1.43-1.431a.868.868 0 00-1.229 0L20 24.162 6.914 11.105a.868.868 0 00-1.229 0l-1.43 1.43a.868.868 0 000 1.23l15.13 15.13c.34.34.89.34 1.23 0l15.13-15.13a.868.868 0 000-1.23z"
  })));
}
export default SvgChevronLightDown;